import { Skeleton } from 'antd';

interface ListItemLoadingProps {
  type?: 'avatar' | 'text';
}

export function ListItemSkeleton({
  type = 'text',
}: Readonly<ListItemLoadingProps>) {
  return (
    <div className='w-full h-full p-6 space-y-6 bg-wl-background rounded-lg'>
      {[...Array(5)].map((_, i) => (
        <div key={i} className='w-full p-4 rounded-lg space-y-4'>
          {type === 'avatar' ? (
            <div className='flex items-center w-full space-x-4'>
              <Skeleton.Avatar
                active
                size={32}
                shape='circle'
                className='dark:bg-gray-200'
              />
              <div className='flex flex-col flex-1 space-y-2'>
                <Skeleton.Input
                  active
                  size='small'
                  className='!w-full rounded-lg dark:bg-gray-200'
                />
              </div>
            </div>
          ) : (
            <div className='flex flex-col w-full justify-center space-y-2'>
              <Skeleton.Input
                active
                size='default'
                className='!w-full rounded-lg h-6 dark:bg-gray-200'
              />
            </div>
          )}
        </div>
      ))}
    </div>
  );
}
